import { useEffect, useState } from "react";
import { SUPPORTED_LANGUAGES } from "../utils/config";
import { DEFAULT_LANGUAGE } from "../utils/config";

const getValidLanguage = (language) => {
	return SUPPORTED_LANGUAGES.includes(language) ? language : DEFAULT_LANGUAGE;
};

export function useLangActive() {
	const [lang, setLang] = useState(DEFAULT_LANGUAGE);
	useEffect(() => {
		if (typeof YaGames === "undefined" || typeof YaGames.init !== "function") {
			console.error("ysdk.environment.i18n.lang");
			return;
		} else {
			const yandexLang = ysdk.environment.i18n.lang;
			console.log("ysdk.environment.i18n.lang.", yandexLang);
			setLang(getValidLanguage(yandexLang));
		}
	}, []);

	return [lang, setLang];
}
